import React from 'react';
import { Building2, Zap, Briefcase, Unlock } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
export function ValueProposition() {
  const {
    t
  } = useTranslations();
  const features = [{
    icon: <Building2 className="w-6 h-6 text-[#00E676]" data-id="element-537" />,
    title: t('value.feature1.title'),
    description: t('value.feature1.desc')
  }, {
    icon: <Briefcase className="w-6 h-6 text-[#00E676]" data-id="element-538" />,
    title: t('value.feature2.title'),
    description: t('value.feature2.desc')
  }, {
    icon: <Zap className="w-6 h-6 text-[#00E676]" data-id="element-539" />,
    title: t('value.feature3.title'),
    description: t('value.feature3.desc')
  }, {
    icon: <Unlock className="w-6 h-6 text-[#00E676]" data-id="element-540" />,
    title: t('value.feature4.title'),
    description: t('value.feature4.desc')
  }];
  return <section className="py-20 bg-white overflow-hidden" data-id="element-541">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-542">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-543">
          {/* Left Content */}
          <div className="order-2 lg:order-1" data-id="element-544">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-545">
              {t('value.title')}{' '}
              <span className="text-[#00E676]" data-id="element-546">
                {t('value.titleHighlight')}
              </span>
              .
            </h2>
            <p className="text-lg text-gray-600 mb-10 leading-relaxed" data-id="element-547">
              {t('value.subtitle')}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-548">
              {features.map((feature, index) => <div key={index} className="flex flex-col items-start" data-id="element-549">
                  <div className="p-3 bg-green-50 rounded-lg mb-4" data-id="element-550">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-551">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-552">{feature.description}</p>
                </div>)}
            </div>
          </div>

          {/* Right Content - Image with Floating Cards */}
          <div className="order-1 lg:order-2 relative" data-id="element-553">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-554">
              <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Professionals discussing document" className="w-full h-full object-cover" data-id="element-555" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-556"></div>
            </div>

            {/* Floating Cards */}
            <div className="absolute top-10 -left-6 bg-white p-4 rounded-lg shadow-xl border-l-4 border-[#00E676] hidden md:block animate-fade-in-up" data-id="element-557">
              <p className="text-xs text-gray-500 uppercase font-semibold" data-id="element-558">
                Status
              </p>
              <p className="text-lg font-bold text-gray-900" data-id="element-559">
                $250,000 Approved
              </p>
            </div>

            <div className="absolute bottom-20 -right-6 bg-white p-4 rounded-lg shadow-xl border-l-4 border-[#00E676] hidden md:block animate-fade-in-up delay-100" data-id="element-560">
              <p className="text-xs text-gray-500 uppercase font-semibold" data-id="element-561">
                New LLC
              </p>
              <p className="text-lg font-bold text-gray-900" data-id="element-562">$75,000 Funded</p>
            </div>

            <div className="absolute bottom-10 -left-10 bg-white p-4 rounded-lg shadow-xl border-l-4 border-[#00E676] hidden md:block animate-fade-in-up delay-200" data-id="element-563">
              <p className="text-xs text-gray-500 uppercase font-semibold" data-id="element-564">
                Working Capital
              </p>
              <p className="text-lg font-bold text-gray-900" data-id="element-565">$120,000 Sent</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}